import { jwtDecode, JwtPayload } from 'jwt-decode';

import { UserType } from '@src/types/main';

export type DecodedToken = JwtPayload & UserType;

export const getToken = (key = 'TOKEN') => {
  return localStorage.getItem(key);
};

export const setToken = (token: string, key = 'TOKEN') => {
  localStorage.setItem(key, token);
};

export const deleteToken = (key = 'TOKEN') => {
  localStorage.removeItem(key);
};

export const decodeToken = (token: string): DecodedToken => {
  return jwtDecode(token);
};

export const setSessionToken = (token: string, key = 'TOKEN') => {
  sessionStorage.setItem(key, token);
};

export const getSessionToken = (key = 'TOKEN') => {
  return sessionStorage.getItem(key);
};

export const deleteSessionToken = (key = 'TOKEN') => {
  sessionStorage.removeItem(key);
};

export const isTokenValid = (token: string | null) => {
  if (!token) return false;

  const decoded = jwtDecode(token);

  const currentTime = Date.now() / 1000;

  return decoded?.exp !== undefined && decoded.exp > currentTime;
};
